import { render, staticRenderFns } from "./TreatPlanTable.vue?vue&type=template&id=603d6e17&"
import script from "./TreatPlanTable.vue?vue&type=script&lang=js&"
export * from "./TreatPlanTable.vue?vue&type=script&lang=js&"
import style0 from "./TreatPlanTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports